module.exports = "https://static.wmbcdn.com/uniweb/images/e879e5ca417645eb7af4022b5a867039.svg";